import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RoutePath, VipProgramTab, generateRoutePath } from '../../app/router/config';
import NoCtaWallet from '../../components/common/no-cta-wallet';
import Header from '../../components/vip-program/header';
import History from '../../components/vip-program/history';
import Information from '../../components/vip-program/information';
import MyPerks from '../../components/vip-program/my-perks';
import { UserContext } from '../../context/user';
import { useVipProgram } from '../../hooks/cta-token/use-vip-program';
import Layout from '../../layout';
export default function VipProgram() {
    var t = useI18n().t;
    var user = useContext(UserContext).user;
    var tab = useParams().tab;
    var navigate = useNavigate();
    var _a = useVipProgram(), history = _a.history, perks = _a.perks, stakingVp = _a.stakingVp, consumptionVp = _a.consumptionVp, goldPoints = _a.goldPoints, redPoints = _a.redPoints;
    if (user === null && tab !== VipProgramTab.INFORMATION) {
        navigate(generateRoutePath(RoutePath.ROOT, {}), { replace: true });
    }
    var tabs = [
        {
            label: t('vip-program.tab.my-perks'),
            path: generateRoutePath(RoutePath.VIP_PROGRAM, { tab: VipProgramTab.MY_PERKS }),
            selected: tab === VipProgramTab.MY_PERKS,
        },
        {
            label: t('vip-program.tab.history'),
            path: generateRoutePath(RoutePath.VIP_PROGRAM, { tab: VipProgramTab.HISTORY }),
            selected: tab === VipProgramTab.HISTORY,
        },
        {
            label: t('vip-program.tab.information'),
            path: generateRoutePath(RoutePath.VIP_PROGRAM, { tab: VipProgramTab.INFORMATION }),
            selected: tab === VipProgramTab.INFORMATION,
        },
    ];
    return (_jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, { loyaltyLevel: perks === null || perks === void 0 ? void 0 : perks.loyaltyLevel, loyaltyPoints: perks === null || perks === void 0 ? void 0 : perks.loyaltyPoints, tabs: tabs }), !(user === null || user === void 0 ? void 0 : user.mpcWalletAddress) && tab !== VipProgramTab.INFORMATION ? (_jsx(NoCtaWallet, {})) : (_jsx(_Fragment, { children: perks && (_jsxs(_Fragment, { children: [tab === VipProgramTab.MY_PERKS && (_jsx(MyPerks, { consumptionVp: consumptionVp, goldPoints: goldPoints, redPoints: redPoints, stakingVp: stakingVp, userPerks: perks })), tab === VipProgramTab.HISTORY && _jsx(History, { history: history }), tab === VipProgramTab.INFORMATION && (_jsx(Information, { globalData: perks.perksData.global, loyaltyLevel: perks.loyaltyLevel, tcgData: perks.perksData.tcg }))] })) }))] }) }));
}
